<app-material>
    <div *ngIf="!isMobile" class="header" header>
        <app-display-label *ngIf="type=='lines'"
                           label="{{'lift-operator.incoming-tool-request.manufacturing-line' | translate}}"
                           [value]="selectedToolReturn.line?.name">
        </app-display-label>
        <app-display-label
            label="{{'lift-operator.incoming-tool-request.createdBy'| translate}}"
            [value]="selectedToolReturn.createdBy?.fullName">
        </app-display-label>
        <app-display-label *ngIf="type==='facilities'"
                           label="{{'lift-operator.incoming-tool-request.facility'| translate}}"
                           [value]="selectedToolReturn.facility?.name">
        </app-display-label>
        <app-display-label
            label="{{'lift-operator.incoming-tool-request.date' | translate}}"
            [value]="selectedToolReturn.createdDate">
        </app-display-label>
        <app-display-label
            label="{{'lift-operator.incoming-tool-request.status' | translate}}"
            [value]="selectedToolReturn.status">
        </app-display-label>
    </div>
    <div class="content" body>
        <div *ngIf="isMobile" class="stats">
            <app-display-label *ngIf="type=='lines'"
                               label="{{'lift-operator.incoming-tool-request.manufacturing-line' | translate}}"
                               [value]="selectedToolReturn.line?.name">
            </app-display-label>
            <app-display-label
                label="{{'lift-operator.incoming-tool-request.createdBy'| translate}}"
                [value]="selectedToolReturn.createdBy?.fullName">
            </app-display-label>
            <app-display-label *ngIf="type==='facilities'"
                               label="{{'lift-operator.incoming-tool-request.facility'| translate}}"
                               [value]="selectedToolReturn.facility?.name">
            </app-display-label>
            <app-display-label
                label="{{'lift-operator.incoming-tool-request.date' | translate}}"
                [value]="selectedToolReturn.createdDate">
            </app-display-label>
            <app-display-label
                label="{{'lift-operator.incoming-tool-request.status' | translate}}"
                [value]="selectedToolReturn.status">
            </app-display-label>
        </div>
        <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
        <app-tool-scan-tree *ngIf="!isLoading"
                            [mode]="'displayGroupedByLocation'"
                            [isMaterial]="false"
                            [allExpanded]="true"
                            [parameters]="[{'leafActionIcon':'select_all'}]"
                            [items]="selectedTools"
                            (leafIconClick)="onLeafIconClick($event)">
        </app-tool-scan-tree>
    </div>
    <div class="footer" footer>
        <app-button
            type="primary"
            class="back"
            (click)="onBack()">{{
                'generic.buttons.back' |
                    translate
            }}
        </app-button>
        <app-button
            type="primary"
            [disabled]="isLoading"
            (click)="onProcessToolReturn()">
            {{ 'generic.buttons.approve' | translate }}
        </app-button>
    </div>
</app-material>

<app-confirmation-modal (scanEvent)="onConfirmProcess($event)"
                        (confirmEvent)="onConfirmProcess($event)"
                        (invalidBadge)="onInvalidBadge($event)"
                        [isConfirmationInProgress]="isConfirmationInProgress"
                        [confirmOnlyMode]="isMobile"
                        [title]="'lift-operator.incoming-tools-returned.title' | translate"
                        [question]="'lift-operator.incoming-tools-returned.question' | translate"
                        [message]="isMobile ? '' : 'lift-operator.incoming-tools-returned.message' | translate"
                        [displayReasonMode]="false">
</app-confirmation-modal>

<app-tool-position-modal
    [tool]="selectedTool"
    [positions]="selectedToolPositions"
    (assign)="onAssignToolPosition($event)">
</app-tool-position-modal>

<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage"
                        [confirmOnlyMode]="true"
                        [showConfirmButton]="false ">
</app-confirmation-modal>


<app-logout-modal title="{{'lift-operator.incoming-tools-returned.logoutTitle' | translate}}"
                  infoMessage="{{'lift-operator.incoming-tools-returned.logoutText' | translate}}"
                  [redirectToHome]="false"
                  (continue)="onContinue()"
                  [timer]="10">
</app-logout-modal>
